import { render, staticRenderFns } from "./create.vue?vue&type=template&id=d6c699bc&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
import style1 from "./create.vue?vue&type=style&index=1&id=d6c699bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c699bc",
  null
  
)

export default component.exports